import { Stripe, loadStripe } from '@stripe/stripe-js';

import { http } from 'services/base/http';

let stripePromiseObject: Promise<Stripe | null>;

export function useStripePromise() {
    if (!stripePromiseObject) {
        stripePromiseObject = http.post('/billing/backend/stripe/key')
            .then((response) => loadStripe(response.data))
            .catch(() => null);
    }
    return stripePromiseObject;
}
